// Stable DOM anchor for the 5-option branch-choices flowchart at the root
// node, plus the "jump back up to it" scroll helper. Kept as a leaf module
// (no component imports) so end-cap components like ScenarioEndNavGrid can
// target the choice point without pulling the whole choices tree into their
// import graph (PlaybookBranchChoices → branch previews → markdown content →
// end caps would otherwise form a cycle).

export const PLAYBOOK_BRANCH_FLOWCHART_ID = 'playbook-branch-flowchart'

// Where the buttons row lands after a branch selection: this fraction of the
// viewport height down from the top, so it's the same resting spot every
// click regardless of where the reader clicked from (rather than snapping to
// the top). Shared with usePlaybookScrollState's above-the-choice-point
// boundary, which must treat this resting position as AT the choice point.
export const BRANCH_CHOICES_VIEWPORT_FRACTION = 0.4


// Pixels above the choice-point flowchart to leave when scrolling it into view.
export const BRANCH_CLICK_SCROLL_OFFSET_PX = 80

// Scroll the page so the choice-point flowchart sits just below the top of
// the viewport. Retries a few frames since the flowchart may not yet be in
// the DOM right after the branch state changes (e.g. when the
// perspective-above-flowchart row is being mounted for the first time).
export const scrollToChoicePointHeader = (maxAttempts = 30) => {
  let attempts = 0
  const tick = () => {
    const el = document.getElementById(PLAYBOOK_BRANCH_FLOWCHART_ID)
    if (el) {
      const top =
        el.getBoundingClientRect().top + window.scrollY - BRANCH_CLICK_SCROLL_OFFSET_PX
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
      return
    }
    if (++attempts < maxAttempts) requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
}
